<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_SEARCH_COND')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectSearchCond"
              v-model="queryData.searchCond"
              codeId="COD_BBS_SCR_CON"
              :defaultOption="'all'"
              class="width60"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="queryData.searchText"
              maxlength="100"
              :disabled="false"
              :readonly="false"
              @keyup.enter="onClickSearch"
              @keyup="onKeyUpInput"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_BBS_TYP')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectBbsType"
              v-model="queryData.bbsType"
              codeId="COD_BBS_TYPE"
              :defaultOption="'all'"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label
              :label="$t('MSG_TXT_CATG_GRP_NM')"
              :vertical="false"
            />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              v-model="bbsGroupName"
              :disabled="true"
              :readonly="false"
            />
            <sui-button
              type="button"
              class="comm_btn_InputScr"
              @click="categoryPopupOpenOrClose"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t('MSG_BTN_RESET') }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t('MSG_BTN_SEARCH') }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-grid
        ref="grdList"
        :columns="gridColumns0"
        :hideHeader="false"
        :initial-pagesize="5"
        :showCountControl="true"
        :showDisplayCountControl="true"
        :dataset="'dataset0'"
        :rowMovable="false"
        :multiselect="false"
        :pageable="false"
        @rowselect="onRowSelect"
      />
      <div class="mrB30" />
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="setCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :pageId="contextPageId"
          :selectedPageId="selectedPageId"
          :selectedGridRowData="selectedGridRowData"
          :selectedPopupParam="selectedPopupParam"
          @openPopup="tabPopupOpenOrClose"
          @research="onClickSearch"
          @clearGridSelection="clearGridSelection"
          @openMenuPopup="setMenuPageId"
          @page-deactivate="handleChildDeactivated"
          @page-activate="handleChildActivated"
        />
      </sui-page-tab-box-type>
      <!-- 검색조건 팝업 -->
      <sui-popup
        v-model="isShownCategoryPopup"
        :title="$t('MSG_TIT_CATG_GRP_DTL_POPUP')"
      >
        <p01
          :parentPageId="contextPageId"
          :callByTab="false"
          @closePopup="categoryPopupOpenOrClose"
          @setCategoryData="onSelectCategoryGroup"
        />
      </sui-popup>
      <!-- 탭 팝업 -->
      <sui-popup
        v-model="isShownTabPopup"
        :title="$t('MSG_TIT_CATG_GRP_DTL_POPUP')"
      >
        <p01
          :parentPageId="contextPageId"
          :callByTab="true"
          @closePopup="tabPopupOpenOrClose"
          @popupParam="setPopupParam"
        />
      </sui-popup>
      <sui-popup
        v-model="isShownMenuPopup"
        :title="$t('MSG_TIT_MENU_RGST')"
      >
        <p02
          :parentPageId="contextPageId"
          :menuPageId="menuPageId"
          @closePopup="menuPopupOpenOrClose"
        />
      </sui-popup>
    </sui-page-contents>
  </sui-page>
</template>
<script>
import BasePage from '~cm/components/BasePage';
import tab01 from './components/PGE_CLB_00008_T01.vue';
import tab02 from '../../../CM/pages/U/components/PGE_CMU_00001_T07.vue';
import p01 from './components/PGE_CLB_00008_P01';
import p02 from './components/PGE_CLB_00008_P02';

export default {
  name: 'PGE_CLB_00008', // eslint-disable-line vue/name-property-casing
  components: {
    tab01,
    tab02,
    p01,
    p02,
  },
  extends: BasePage,
  data() {
    return {
      selectedGridRowData: {},
      selectedPopupParam: {},
      selectedPageId: '',
      menuPageId: '',
      isShownCategoryPopup: false,
      isShownTabPopup: false,
      isShownMenuPopup: false,
      defaultTabIndex: 0,
      currentTabComponent: 'tab01',
      queryData: {
        searchCond: '',
        searchText: '',
        bbsType: '',
        bbsGroupId: '',
      },
      bbsGroupName: '',
      searchOldText: '',
    };
  },
  computed: {},
  watch: {},
  datasets: [
    {
      id: 'dataset0',
      type: 'local',
      datafields: [
        {
          name: 'bbsTypeCntn',
          type: 'string',
          map: 'bbsTypeCntn',
        },
        {
          name: 'bbsName',
          type: 'string',
          map: 'bbsName',
        },
        {
          name: 'bbsboardId',
          type: 'string',
          map: 'bbsboardId',
        },
        {
          name: 'bbsCatgGrpName',
          type: 'string',
          map: 'bbsCatgGrpName',
        },
        {
          name: 'userName',
          type: 'string',
          map: 'userName',
        },
        {
          name: 'firstRgstDtm',
          type: 'string',
          map: 'firstRgstDtm',
        },
        {
          name: 'bbBsicVldPrdCode',
          type: 'string',
          map: 'bbBsicVldPrdCode',
        },
        {
          name: 'newMarkPrdCode',
          type: 'string',
          map: 'newMarkPrdCode',
        },
        {
          name: 'bbsTypeCodeVldVal',
          type: 'string',
          map: 'bbsTypeCodeVldVal',
        },
        {
          name: 'bbsCntn',
          type: 'string',
          map: 'bbsCntn',
        },
        {
          name: 'bbsCatgGrpId',
          type: 'string',
          map: 'bbsCatgGrpId',
        },
        {
          name: 'approveUseYn',
          type: 'string',
          map: 'approveUseYn',
        },
        {
          name: 'answerUseYn',
          type: 'string',
          map: 'answerUseYn',
        },
        {
          name: 'totalModificationPermissionYn',
          type: 'string',
          map: 'totalModificationPermissionYn',
        },
        {
          name: 'tbabRestrictSize',
          type: 'string',
          map: 'tbabRestrictSize',
        },
        {
          name: 'attachRestrictSize',
          type: 'string',
          map: 'attachRestrictSize',
        },
        {
          name: 'bbsPageId',
          type: 'string',
          map: 'bbsPageId',
        },
        {
          name: 'bbsPageTitleMsgResoId',
          type: 'string',
          map: 'bbsPageTitleMsgResoId',
        },
        {
          name: 'sendTemplateId',
          type: 'string',
          map: 'sendTemplateId',
        },
        {
          name: 'sendTemplateName',
          type: 'string',
          map: 'sendTemplateName',
        },
        {
          name: 'loginId',
          type: 'string',
          map: 'loginId',
        },
      ],
    },
  ],
  created() {
    this.gridColumns0 = [
      {
        text: this.$t('MSG_TXT_SN'),
        datafield: '',
        cellsrenderer: (row, column, value) => `<div style="margin: 8.2px;">${row + 1}</div>`,
      },
      {
        text: this.$t('MSG_TXT_BBS_TYP'),
        datafield: 'bbsTypeCntn',
      },
      {
        text: this.$t('MSG_TXT_BBS_NM'),
        datafield: 'bbsName',
      },
      {
        text: this.$t('MSG_TXT_BBS_ID'),
        datafield: 'bbsboardId',
      },
      {
        text: this.$t('MSG_TXT_CATG_GRP_NM'),
        datafield: 'bbsCatgGrpName',
      },
      {
        text: this.$t('MSG_TXT_RGST_USR'),
        datafield: 'userName',
        createwidget: (row, column, value, htmlElement) => {
          utils.getGridCellFactory().createCellUserName(row, column, value, htmlElement, {
            displayType: '1', // '1', '2' - default: '1'
            type: 'link', // 'link', 'sublink' - default: "link"
            loginId: 'loginId',
          },
          this.dataset0, this.$refs.grdList);
        },
        initwidget(row, column, value, htmlElement) {
          utils.getGridCellFactory().refreshCell(row, column, value, htmlElement);
        },
      },
      {
        text: this.$t('MSG_TXT_RGST_DTM'),
        datafield: 'firstRgstDtm',
      },
    ];
    this.tabItems = [
      {
        tabTitle: this.$t('MSG_TXT_BBS'),
        tabComponent: tab01,
      },
      {
        tabTitle: this.$t('MSG_TXT_ROLE'),
        tabComponent: tab02,
      },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  methods: {
    onLoad() {
      const paramData = utils.getParameter(this, 'queryData');
      if (!utils.isEmpty(paramData)) {
        this.queryData = paramData;
        this.onClickSearch();
      }
    },
    setCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].tabComponent;
    },
    onClickSearch() {
      this.dataset0.setRawData([]);
      const queryParams = {
        bullBoardSearchCond: this.queryData.searchCond || '',
        bullBoardSearchCondValue: this.queryData.searchText || '',
        bullBoardType: this.queryData.bbsType || '',
        bbsCtgGprId: this.queryData.bbsGroupId || '',
      };
      http.request(this.contextPageId, 'DTS_CLB_00040', {
        query: queryParams,
      }).then(res => {
        utils.dateformatToClientInArray(res.data, 'firstRgstDtm');
        this.dataset0.setRawData(res.data);
      });
    },
    onClickReset() {
      this.$refs.codeSelectSearchCond.reset();
      this.$refs.codeSelectBbsType.reset();
      this.queryData.searchText = '';
      this.queryData.bbsGroupId = '';
      this.bbsGroupName = '';
      this.searchOldText = '';
    },
    onKeyUpInput() {
      const searchNewText = this.queryData.searchText;
      if (utils.isExistSpecialChar(searchNewText)) {
        utils.messageBox('warning', this.$t('MSG_ALT_CHK_SPECL_CHAR'), null, () => {
          this.queryData.searchText = this.searchOldText;
        });
      } else {
        this.searchOldText = searchNewText;
      }
    },
    categoryPopupOpenOrClose() {
      this.isShownCategoryPopup = !this.isShownCategoryPopup;
    },
    onSelectCategoryGroup(value) {
      this.queryData.bbsGroupId = value.categoryId;
      this.bbsGroupName = value.categoryName;
      this.categoryPopupOpenOrClose();
    },
    tabPopupOpenOrClose() {
      this.isShownTabPopup = !this.isShownTabPopup;
    },
    onRowSelect(event) {
      if (event.args.rowindex >= 0) {
        this.selectedGridRowData = event.args.row;
        this.selectedGridRowData.bbsboardIdPostfix = this.selectedGridRowData.bbsboardId.substring(4);
        this.selectedPageId = this.selectedGridRowData.bbsPageId;
      }
    },
    setPopupParam(data, param) {
      this[param] = data;
    },
    clearGridSelection() {
      this.dataset0.clearSelection();
      this.selectedGridRowData = {};
    },
    menuPopupOpenOrClose() {
      this.isShownMenuPopup = !this.isShownMenuPopup;
    },
    setMenuPageId(data) {
      this.menuPageId = data;
      this.menuPopupOpenOrClose();
    },
  },
};
</script>
<style scoped>
</style>
